export default class HUD {
	private menüElement = document.querySelector('.menü')! as HTMLElement;
	private hauptMenüElement = document.querySelector('.haupt-menü')! as HTMLElement;
	public startKnopf = document.querySelector('.knopf--start')! as HTMLButtonElement;
	public urheberKnopf = document.querySelector('.knopf--urheber')! as HTMLButtonElement;
	public bedienungsAnleitungsKnopf = document.querySelector('.knopf--bedienungs-anleitung')! as HTMLButtonElement;
	public einstellungenKnopf = document.querySelector('.knopf--einstellungen')! as HTMLButtonElement;
	public zurückKnöpfe = document.querySelectorAll('.knopf--zurück')!;
	public urheberSektion = document.querySelector('.urheber')! as HTMLElement;
	public bedienungsAnleitungsSektion = document.querySelector('.bedienungs-anleitung')! as HTMLElement;
	public terrainSchiebeRegler = document.querySelectorAll('.terrain-schieberegler')! as NodeListOf<HTMLInputElement>;
	public spielerFarbe = document.querySelector('#spieler-farbe')! as HTMLInputElement;
	public einstellungenSektion = document.querySelector('.einstellungen')! as HTMLElement;
	private spieleInfoElement = document.querySelector('.spiele-info')! as HTMLElement;
	private punkteZahlElement = document.querySelector('.punkte-zahl')! as HTMLElement;
	private gameOverText = document.querySelector('.gameover-text')!;
	public pausierungsText = document.querySelector('.pause')!;

	änderePunkteZahl(wert: number) {
		this.punkteZahlElement.textContent = wert.toString();
	}

	aufSpielStart() {
		// Verstecke Menü und zeige Spiele Info
		this.spieleInfoElement.classList.remove('inaktiv');
		this.menüElement.classList.add('inaktiv');
	}

	aufGameOver(gameOverText: string) {
		// Zeige Menü und verstecke Spiele Info
		this.spieleInfoElement.classList.add('inaktiv');
		this.menüElement.classList.remove('inaktiv');
		this.gameOverText.textContent = gameOverText;
	}
	// Pfeilschreibweise, damit "this" für die Klasse steht
	public zeigeSektion = (sektion: HTMLElement) => {
		this.hauptMenüElement.classList.add('inaktiv');
		sektion.classList.remove('inaktiv');
	}

	public zeigeMenü = () => {
		this.hauptMenüElement.classList.remove('inaktiv');
		this.urheberSektion.classList.add('inaktiv');
		this.bedienungsAnleitungsSektion.classList.add('inaktiv');
		this.einstellungenSektion.classList.add('inaktiv');
	}
	// Ich hätte dieses Pojekt auf Englisch schreiben sollen...
	public setzeEreignisHöhrer = () => {
		this.urheberKnopf.addEventListener('click', () => this.zeigeSektion(this.urheberSektion));
		this.bedienungsAnleitungsKnopf.addEventListener('click', () => this.zeigeSektion(this.bedienungsAnleitungsSektion));
		[...this.zurückKnöpfe].map((zurückKnopf) => zurückKnopf.addEventListener('click', this.zeigeMenü));
		this.einstellungenKnopf.addEventListener('click', () => this.zeigeSektion(this.einstellungenSektion));
		// Schiberegler in den Einstellungen
		[...this.terrainSchiebeRegler].map((terrainSchiebeRegler) => {
			const schiebeReglerOutput = document.querySelector(`output[for="${terrainSchiebeRegler.id}"]`)! as HTMLInputElement;
			schiebeReglerOutput.textContent = terrainSchiebeRegler.value;
			terrainSchiebeRegler.addEventListener('input', () => {
				schiebeReglerOutput.textContent = terrainSchiebeRegler.value;
			});
		});
	}
}